module.exports = __webpack_public_path__ + "static/img/wechat.22e2590a.jpg";